import React from 'react';
import { MoreVerticalIcon } from 'lucide-react';
interface MetricCardProps {
  label: string;
  value: string;
  icon?: React.ReactNode;
}
export function MetricCard({
  label,
  value,
  icon
}: MetricCardProps) {
  return <div className="bg-white rounded-lg border border-gray-200 p-5 shadow-sm" data-id="element-681">
      <div className="flex items-start justify-between mb-3" data-id="element-682">
        <span className="text-xs font-medium text-blue-600 uppercase tracking-wide" data-id="element-683">
          {label}
        </span>
        <button className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-684">
          <MoreVerticalIcon size={16} data-id="element-685" />
        </button>
      </div>
      <div className="text-3xl font-bold text-gray-900" data-id="element-686">{value}</div>
    </div>;
}